import React, { Fragment } from "react";

const CustomerProfile = () => {
  return (
    <Fragment>
      <div>Customer Profile</div>
    </Fragment>
  );
};

export default CustomerProfile;
